import React from 'react';
import { ImageFadeIn } from '../components/animations/ImageFadeIn';
import { ScrollReveal } from '../components/animations/ScrollReveal';
import { DollarSign, Building, Share2, Heart, Shield, Users } from 'lucide-react';
const SupportPage = () => {
  return <div className="w-full min-h-screen bg-white" data-id="element-924">
      {/* Hero Section */}
      <div className="relative min-h-[60vh] flex items-center" data-id="element-925">
        <div className="absolute inset-0 z-0" data-id="element-926">
          <ImageFadeIn src="https://uploadthingy.s3.us-west-1.amazonaws.com/jop9zBgRujeWdeTtyMQTQf/Screenshot_2025-06-06_at_5.11.07_PM.png" alt="Civilians training together" className="w-full h-full object-cover" data-id="element-927" />
          <div className="absolute inset-0 bg-black/60" data-id="element-928"></div>
        </div>
        <div className="relative z-10 w-full pt-36 sm:pt-52 md:pt-56 pb-16 sm:pb-20" data-id="element-929">
          <div className="max-w-5xl mx-auto px-4 sm:px-6 text-center" data-id="element-930">
            <h1 className="text-3xl sm:text-5xl md:text-6xl font-bold text-white tracking-tight mb-4 sm:mb-6" data-id="element-931">
              Support Our Mission
            </h1>
            <p className="text-lg sm:text-xl md:text-2xl text-white/90 max-w-3xl mx-auto font-light leading-relaxed" data-id="element-932">
              Help us build a safer, more resilient Israel through civilian
              training and preparedness
            </p>
          </div>
        </div>
      </div>
      {/* Why Your Support Matters */}
      <ScrollReveal animation="fade" data-id="element-933">
        <div className="py-16 sm:py-24 bg-white" data-id="element-934">
          <div className="max-w-5xl mx-auto px-4 sm:px-6" data-id="element-935">
            <div className="text-center mb-16" data-id="element-936">
              <div className="inline-flex items-center justify-center mb-6" data-id="element-937">
                <Heart className="w-8 h-8 text-red-500 mr-3" data-id="element-938" />
                <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 tracking-tight" data-id="element-939">
                  Why Your Support Matters
                </h2>
              </div>
              <p className="text-xl text-gray-700 max-w-3xl mx-auto" data-id="element-940">
                Protecting Israeli families is critical to the survival of
                Israel's present and future. 100% of all donations go directly
                to training famililes in Samaria.
              </p>
            </div>
            <ScrollReveal animation="scale" delay={0.2} data-id="element-941">
              <div className="mb-16" data-id="element-942">
                <div className="relative rounded-xl overflow-hidden" data-id="element-943">
                  <ImageFadeIn src="https://uploadthingy.s3.us-west-1.amazonaws.com/gPbz3hZ76mcFrXSSdUotxi/Screenshot_2025-06-06_at_5.10.59_PM.png" alt="Civilians practicing emergency response techniques" className="w-full h-auto" data-id="element-944" />
                  <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 to-transparent p-6 sm:p-10" data-id="element-945">
                    <p className="text-white text-lg sm:text-xl font-light max-w-3xl" data-id="element-946">
                      When minutes matter and help is far away, trained
                      civilians become the first and most critical line of
                      defense for their families and communities.
                    </p>
                  </div>
                </div>
              </div>
            </ScrollReveal>
            <ScrollReveal animation="slide-up" data-id="element-947">
              <div className="prose prose-lg max-w-none text-gray-700" data-id="element-948"></div>
            </ScrollReveal>
          </div>
        </div>
      </ScrollReveal>
      {/* Immediate Funding Needs */}
      <ScrollReveal animation="fade" data-id="element-949">
        <div className="py-16 sm:py-24 bg-blue-50" data-id="element-950">
          <div className="max-w-5xl mx-auto px-4 sm:px-6" data-id="element-951">
            <div className="text-center mb-16" data-id="element-952">
              <div className="inline-flex items-center justify-center mb-6" data-id="element-953">
                <Shield className="w-8 h-8 text-blue-500 mr-3" data-id="element-954" />
                <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 tracking-tight" data-id="element-955">
                  Our Immediate Needs
                </h2>
              </div>
              <p className="text-xl text-gray-700 max-w-3xl mx-auto" data-id="element-956">
                We're working to protect vulnerable communities now while
                building for the future
              </p>
            </div>
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12" data-id="element-957">
              <ScrollReveal animation="slide-left" delay={0.1} data-id="element-958">
                <div className="bg-white p-8 sm:p-10 rounded-xl shadow-sm border border-gray-100 relative overflow-hidden" data-id="element-959">
                  <div className="absolute top-0 right-0 w-32 h-32 -mt-10 -mr-10 bg-blue-100 rounded-full opacity-50" data-id="element-960"></div>
                  <div className="relative" data-id="element-961">
                    <div className="text-3xl sm:text-4xl font-bold text-blue-600 mb-4" data-id="element-962">
                      $750,000
                    </div>
                    <h3 className="text-xl font-semibold text-gray-900 mb-6" data-id="element-963">
                      Immediate Community Training
                    </h3>
                    <div className="prose prose-lg text-gray-700" data-id="element-964">
                      <p data-id="element-965">
                        While we work to build our permanent training center,
                        vulnerable communities need training now. Currently we
                        have one system with one full time trainer helping
                        prepare these communities. The need for this training is
                        urgent and requires additional trainers and equipment.
                        Additional funding will allow us to:
                      </p>
                    </div>
                    <ul className="mt-6 space-y-4" data-id="element-966">
                      <li className="flex items-start" data-id="element-967">
                        <div className="flex-shrink-0 w-6 h-6 rounded-full bg-blue-100 flex items-center justify-center mt-1 mr-3" data-id="element-968">
                          <span className="text-blue-600 text-sm font-semibold" data-id="element-969">
                            1
                          </span>
                        </div>
                        <span className="text-gray-700" data-id="element-970">
                          Hire 2 more full time trainers to enhance training
                          capability throughout the region
                        </span>
                      </li>
                      <li className="flex items-start" data-id="element-971">
                        <div className="flex-shrink-0 w-6 h-6 rounded-full bg-blue-100 flex items-center justify-center mt-1 mr-3" data-id="element-972">
                          <span className="text-blue-600 text-sm font-semibold" data-id="element-973">
                            2
                          </span>
                        </div>
                        <span className="text-gray-700" data-id="element-974">
                          Deploy 2 more portable MILO Range simulators to train
                          high-risk communities
                        </span>
                      </li>
                      <li className="flex items-start" data-id="element-975">
                        <div className="flex-shrink-0 w-6 h-6 rounded-full bg-blue-100 flex items-center justify-center mt-1 mr-3" data-id="element-976">
                          <span className="text-blue-600 text-sm font-semibold" data-id="element-977">
                            3
                          </span>
                        </div>
                        <span className="text-gray-700" data-id="element-978">
                          Purchase 2 trauma manikins and medical supplies for
                          training
                        </span>
                      </li>
                      <li className="flex items-start" data-id="element-979">
                        <div className="flex-shrink-0 w-6 h-6 rounded-full bg-blue-100 flex items-center justify-center mt-1 mr-3" data-id="element-980">
                          <span className="text-blue-600 text-sm font-semibold" data-id="element-981">
                            4
                          </span>
                        </div>
                        <span className="text-gray-700" data-id="element-982">
                          Fund filming of approximately 25 realistic scenarios
                          in the region for use on the MILO simulator training
                          system
                        </span>
                      </li>
                      <li className="flex items-start" data-id="element-983">
                        <div className="flex-shrink-0 w-6 h-6 rounded-full bg-blue-100 flex items-center justify-center mt-1 mr-3" data-id="element-984">
                          <span className="text-blue-600 text-sm font-semibold" data-id="element-985">
                            5
                          </span>
                        </div>
                        <span className="text-gray-700" data-id="element-986">
                          Construct two weapons training ranges (one rifle and
                          one pistol) for exclusive civilian training
                        </span>
                      </li>
                    </ul>
                  </div>
                </div>
              </ScrollReveal>
              <ScrollReveal animation="slide-right" delay={0.1} data-id="element-987">
                <div className="bg-white p-8 sm:p-10 rounded-xl shadow-sm border border-gray-100 relative overflow-hidden" data-id="element-988">
                  <div className="absolute top-0 right-0 w-32 h-32 -mt-10 -mr-10 bg-blue-100 rounded-full opacity-50" data-id="element-989"></div>
                  <div className="relative" data-id="element-990">
                    <div className="text-3xl sm:text-4xl font-bold text-blue-600 mb-4" data-id="element-991">
                      $14.1 Million
                    </div>
                    <h3 className="text-xl font-semibold text-gray-900 mb-6" data-id="element-992">
                      Complete Training Center
                    </h3>
                    <div className="prose prose-lg text-gray-700" data-id="element-993">
                      <p data-id="element-994">
                        This funding will allow us to complete construction of
                        the Samaria Regional Training Center and launch
                        full-scale operations, including:
                      </p>
                    </div>
                    <ul className="mt-6 space-y-4" data-id="element-995">
                      <li className="flex items-start" data-id="element-996">
                        <div className="flex-shrink-0 w-6 h-6 rounded-full bg-blue-100 flex items-center justify-center mt-1 mr-3" data-id="element-997">
                          <span className="text-blue-600 text-sm font-semibold" data-id="element-998">
                            1
                          </span>
                        </div>
                        <span className="text-gray-700" data-id="element-999">
                          Complete construction of all training facilities and
                          ranges
                        </span>
                      </li>
                      <li className="flex items-start" data-id="element-1000">
                        <div className="flex-shrink-0 w-6 h-6 rounded-full bg-blue-100 flex items-center justify-center mt-1 mr-3" data-id="element-1001">
                          <span className="text-blue-600 text-sm font-semibold" data-id="element-1002">
                            2
                          </span>
                        </div>
                        <span className="text-gray-700" data-id="element-1003">
                          Build 25-bed dormitory and full-service dining hall
                          for 150 people
                        </span>
                      </li>
                      <li className="flex items-start" data-id="element-1004">
                        <div className="flex-shrink-0 w-6 h-6 rounded-full bg-blue-100 flex items-center justify-center mt-1 mr-3" data-id="element-1005">
                          <span className="text-blue-600 text-sm font-semibold" data-id="element-1006">
                            3
                          </span>
                        </div>
                        <span className="text-gray-700" data-id="element-1007">
                          Develop comprehensive curriculum and train instructors
                        </span>
                      </li>
                      <li className="flex items-start" data-id="element-1008">
                        <div className="flex-shrink-0 w-6 h-6 rounded-full bg-blue-100 flex items-center justify-center mt-1 mr-3" data-id="element-1009">
                          <span className="text-blue-600 text-sm font-semibold" data-id="element-1010">
                            4
                          </span>
                        </div>
                        <span className="text-gray-700" data-id="element-1011">
                          Fund first-year operations to train 50,000 civilians
                        </span>
                      </li>
                    </ul>
                    <div className="mt-8" data-id="element-1012">
                      <div className="bg-blue-50 p-4 rounded-lg" data-id="element-1013">
                        <p className="text-gray-700 font-medium" data-id="element-1014">
                          Land has been zoned and approved for the center, with
                          infrastructure planning underway and local agreements
                          pending.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </ScrollReveal>
            </div>
          </div>
        </div>
      </ScrollReveal>
      {/* Training Focus Areas */}
      <ScrollReveal animation="fade" data-id="element-1015"></ScrollReveal>
      {/* How You Can Help */}
      <ScrollReveal animation="fade" data-id="element-1016">
        <div className="py-16 sm:py-24 bg-gray-50" data-id="element-1017">
          <div className="max-w-5xl mx-auto px-4 sm:px-6" data-id="element-1018">
            <div className="text-center mb-16" data-id="element-1019">
              <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-6 tracking-tight" data-id="element-1020">
                How You Can Help
              </h2>
              <p className="text-xl text-gray-700 max-w-3xl mx-auto" data-id="element-1021">
                Join our mission to protect Israeli civilians through training
                and preparedness
              </p>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16" data-id="element-1022">
              <ScrollReveal animation="slide-up" delay={0.1} data-id="element-1023">
                <div className="bg-white p-8 rounded-xl shadow-sm border border-gray-100 relative overflow-hidden" data-id="element-1024">
                  <div className="absolute top-0 right-0 w-24 h-24 -mt-8 -mr-8 bg-blue-50 rounded-full" data-id="element-1025"></div>
                  <div className="relative" data-id="element-1026">
                    <div className="w-14 h-14 rounded-full bg-blue-50 flex items-center justify-center mb-6" data-id="element-1027">
                      <DollarSign className="w-7 h-7 text-blue-500" data-id="element-1028" />
                    </div>
                    <h3 className="text-xl font-semibold text-gray-900 mb-4" data-id="element-1029">
                      Give
                    </h3>
                    <p className="text-gray-700 mb-6" data-id="element-1030">
                      Make a tax-deductible donation through our U.S. 501(c)(3)
                      Israeli Civilian Training Fund{' '}
                      <span className="text-sm italic" data-id="element-1031"></span> to support
                      immediate training needs and long-term center development.
                    </p>
                    <a href="https://donate.stripe.com/7sY5kw7P1eO24x90y314401" target="_blank" rel="noopener noreferrer" className="text-blue-600 font-medium hover:text-blue-700" data-id="element-1032">
                      Donate now →
                    </a>
                  </div>
                </div>
              </ScrollReveal>
              <ScrollReveal animation="slide-up" delay={0.2} data-id="element-1033">
                <div className="bg-white p-8 rounded-xl shadow-sm border border-gray-100 relative overflow-hidden" data-id="element-1034">
                  <div className="absolute top-0 right-0 w-24 h-24 -mt-8 -mr-8 bg-blue-50 rounded-full" data-id="element-1035"></div>
                  <div className="relative" data-id="element-1036">
                    <div className="w-14 h-14 rounded-full bg-blue-50 flex items-center justify-center mb-6" data-id="element-1037">
                      <Building className="w-7 h-7 text-blue-500" data-id="element-1038" />
                    </div>
                    <h3 className="text-xl font-semibold text-gray-900 mb-4" data-id="element-1039">
                      Partner
                    </h3>
                    <p className="text-gray-700 mb-6" data-id="element-1040">
                      Introduce corporate grants, in-kind equipment donations,
                      or leverage your organizational resources to advance our
                      mission of civilian protection.
                    </p>
                    <a href="/contact" className="text-blue-600 font-medium hover:text-blue-700" data-id="element-1041">
                      Become a partner →
                    </a>
                  </div>
                </div>
              </ScrollReveal>
              <ScrollReveal animation="slide-up" delay={0.3} data-id="element-1042">
                <div className="bg-white p-8 rounded-xl shadow-sm border border-gray-100 relative overflow-hidden" data-id="element-1043">
                  <div className="absolute top-0 right-0 w-24 h-24 -mt-8 -mr-8 bg-blue-50 rounded-full" data-id="element-1044"></div>
                  <div className="relative" data-id="element-1045">
                    <div className="w-14 h-14 rounded-full bg-blue-50 flex items-center justify-center mb-6" data-id="element-1046">
                      <Share2 className="w-7 h-7 text-blue-500" data-id="element-1047" />
                    </div>
                    <h3 className="text-xl font-semibold text-gray-900 mb-4" data-id="element-1048">
                      Share
                    </h3>
                    <p className="text-gray-700 mb-6" data-id="element-1049">
                      Host an awareness event, share our story online, or help
                      us connect with others who can support this critical
                      initiative for Israel's security.
                    </p>
                    <a href="/contact" className="text-blue-600 font-medium hover:text-blue-700" data-id="element-1050">
                      Spread the word →
                    </a>
                  </div>
                </div>
              </ScrollReveal>
            </div>
          </div>
        </div>
      </ScrollReveal>
      {/* Long-Term Vision */}
      <ScrollReveal animation="fade" data-id="element-1051">
        <div className="py-16 sm:py-24 bg-white" data-id="element-1052">
          <div className="max-w-5xl mx-auto px-4 sm:px-6" data-id="element-1053">
            <div className="text-center mb-16" data-id="element-1054">
              <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-6 tracking-tight" data-id="element-1055">
                Our Long-Term Vision
              </h2>
              <p className="text-xl text-gray-700 max-w-3xl mx-auto" data-id="element-1056">
                Building a sustainable network of training centers across Israel
              </p>
            </div>
            <ScrollReveal animation="slide-up" data-id="element-1057">
              <div className="prose prose-lg max-w-none text-gray-700 mb-12" data-id="element-1058">
                <p data-id="element-1059">
                  Our long-term vision extends beyond the initial Samaria
                  Regional Training Center. We aim to establish a network of
                  regional centers strategically located across Israel to ensure
                  all civilians have access to this critical training.
                </p>
                <p data-id="element-1060">
                  To ensure the sustainability of these centers, we're
                  developing a multi-faceted funding model that includes:
                </p>
              </div>
            </ScrollReveal>
            <div className="space-y-4 mb-16" data-id="element-1061">
              <ScrollReveal animation="slide-up" delay={0.1} data-id="element-1062">
                <div className="bg-gray-50 p-6 rounded-lg" data-id="element-1063">
                  <p className="text-gray-700 text-base sm:text-lg" data-id="element-1064">
                    Donor Sponsorship Programs – Establish annual and lifetime
                    donation tiers in direct support of the training center.
                  </p>
                </div>
              </ScrollReveal>
              <ScrollReveal animation="slide-up" delay={0.2} data-id="element-1065">
                <div className="bg-gray-50 p-6 rounded-lg" data-id="element-1066">
                  <p className="text-gray-700 text-base sm:text-lg" data-id="element-1067">
                    Corporate Grants – Pursue funding from Israeli focused
                    organizations.
                  </p>
                </div>
              </ScrollReveal>
              <ScrollReveal animation="slide-up" delay={0.3} data-id="element-1068">
                <div className="bg-gray-50 p-6 rounded-lg" data-id="element-1069">
                  <p className="text-gray-700 text-base sm:text-lg" data-id="element-1070">
                    Family Sponsorship Program – Enable donators to sponsor
                    individual/specific family members across Israel
                  </p>
                </div>
              </ScrollReveal>
              <ScrollReveal animation="slide-up" delay={0.4} data-id="element-1071">
                <div className="bg-gray-50 p-6 rounded-lg" data-id="element-1072">
                  <p className="text-gray-700 text-base sm:text-lg" data-id="element-1073">
                    Civilian Scholarships – Civilians training scholarship
                    programs to ensure all civilians can attend.
                  </p>
                </div>
              </ScrollReveal>
              <ScrollReveal animation="slide-up" delay={0.5} data-id="element-1074">
                <div className="bg-gray-50 p-6 rounded-lg" data-id="element-1075">
                  <p className="text-gray-700 text-base sm:text-lg" data-id="element-1076">
                    Municipal Sponsorship Program – Utilization of government
                    grants to sponsor training.
                  </p>
                </div>
              </ScrollReveal>
            </div>
          </div>
        </div>
      </ScrollReveal>
      {/* Performance Metrics */}
      <ScrollReveal animation="fade" data-id="element-1077">
        <div className="py-16 sm:py-24 bg-blue-50" data-id="element-1078">
          <div className="max-w-5xl mx-auto px-4 sm:px-6" data-id="element-1079">
            <div className="text-center mb-16" data-id="element-1080">
              <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-6 tracking-tight" data-id="element-1081">
                Measuring Our Impact
              </h2>
              <p className="text-xl text-gray-700 max-w-3xl mx-auto" data-id="element-1082">
                Transparent reporting on how your support is making a difference
              </p>
            </div>
            <div className="space-y-6 max-w-3xl mx-auto mb-16" data-id="element-1083">
              {impactMetrics.map((metric, index) => <ScrollReveal key={index} animation="slide-up" delay={index * 0.1} data-id="element-1084">
                  <div className="flex items-start" data-id="element-1085">
                    <div className="flex-shrink-0 w-10 h-10 rounded-full bg-blue-100 flex items-center justify-center mt-1 mr-4" data-id="element-1086">
                      <span className="text-blue-600 font-semibold" data-id="element-1087">
                        {index + 1}
                      </span>
                    </div>
                    <div className="bg-white p-5 rounded-lg shadow-sm border border-gray-100 flex-grow" data-id="element-1088">
                      <p className="text-gray-700" data-id="element-1089">{metric}</p>
                    </div>
                  </div>
                </ScrollReveal>)}
            </div>
            <ScrollReveal animation="fade" delay={0.3} data-id="element-1090">
              <div className="text-center" data-id="element-1091">
                <p className="text-gray-700 mb-8" data-id="element-1092">
                  A comprehensive dashboard will publish these metrics annually
                  to ensure transparency and accountability to our supporters.
                </p>
                <a href="https://donate.stripe.com/7sY5kw7P1eO24x90y314401" target="_blank" rel="noopener noreferrer" className="inline-block px-8 py-4 bg-israel-blue text-white font-semibold rounded-lg hover:bg-israel-blue-light transition-colors text-lg shadow-lg" data-id="element-1093">
                  Donate Now
                </a>
              </div>
            </ScrollReveal>
          </div>
        </div>
      </ScrollReveal>
    </div>;
};
const fundingModel = ['Donor Sponsorship Programs — Establish annual and lifetime donation tiers with appropriate recognition.', 'Corporate Grants — Pursue funding from Israeli-focused organizations and foundations committed to security.', 'Revenue-Generating Training Programs — Offer specialized training for law enforcement and security professionals to subsidize free civilian courses.', 'Civilian Training Scholarship Programs — Ensure all civilians can attend regardless of financial means.', 'Subscription-Based Learning Modules — Develop online courses for remote education and ongoing skill maintenance.'];
const impactMetrics = ['Civilians in need of training 400k. Projected civilians trained 50k per year.', 'Self-defense and emergency response evaluation scores to measure training effectiveness', 'Incident response evaluations and post-training impact assessments', "Ongoing family training to enhance Israel's national security with emerging threats", 'Community resilience indicators and security readiness measurements'];
export default SupportPage;